/**
 * Project: Aniatek
 * Author: Carlos A. Loaiza | Connect & Launch
 * Tel: +52 (667) 247 - 6316
 * Intellectual Property: All rights reserved (c) 2026
 */
 
 <template>
  <div class="seguridad-container">

    <div class="section-header-row">
      <h2 class="section-subtitle">Seguridad y Soporte</h2>
      <span class="status-badge protected" v-if="twoFactorEnabled">
        <i class="fa-solid fa-shield-halved"></i> Protegido
      </span>
    </div>

    <div class="view-card dashboard-card">

      <section class="informacionSeguridad">
        <div class="header-interno">
          <h3 class="security-title">Cambio de Contraseña</h3>
          <p class="security-description">
            Asegúrate de que tu nueva contraseña tenga al menos 8 caracteres y una combinación de letras y números.
          </p>
        </div>

        <div class="form-grid inputs-grid-security">

          <div class="form-group">
            <label for="old-password">Contraseña Actual:</label>
            <div class="password-wrapper">
              <input 
                :type="showPass.old ? 'text' : 'password'" 
                id="old-password"
                placeholder="Ingresa contraseña actual" 
                v-model="passwords.current_password" />
              <i class="fa-solid toggle-icon" :class="showPass.old ? 'fa-eye' : 'fa-eye-slash'"
                @click="showPass.old = !showPass.old"></i>
            </div>
          </div>

          <div class="form-group">
            <label for="new-password">Nueva Contraseña:</label>
            <div class="password-wrapper">
              <input 
                :type="showPass.new ? 'text' : 'password'" 
                id="new-password"
                placeholder="Ingresa nueva contraseña" 
                v-model="passwords.new_password" />
              <i class="fa-solid toggle-icon" :class="showPass.new ? 'fa-eye' : 'fa-eye-slash'"
                @click="showPass.new = !showPass.new"></i>
            </div>
          </div>

          <div class="form-group">
            <label for="confirm-password">Confirmar Nueva Contraseña:</label>
            <div class="password-wrapper">
              <input 
                :type="showPass.confirm ? 'text' : 'password'" 
                id="confirm-password"
                placeholder="Confirma nueva contraseña" 
                v-model="passwords.confirm_password" />
              <i class="fa-solid toggle-icon" :class="showPass.confirm ? 'fa-eye' : 'fa-eye-slash'"
                @click="showPass.confirm = !showPass.confirm"></i>
            </div>
          </div>

        </div>

        <div class="actions-row">
          <Button class="btn-primary-action btn-change-password" @click="changePassword" :disabled="mostrarLoader">
            {{ mostrarLoader ? 'Cargando...' : 'Cambiar Contraseña' }}
          </Button>
        </div>
      </section>

      <section class="informacionAyuda">
        <div class="header-interno">
          <h3 class="security-title">Soporte y Contacto</h3>
          <p class="security-description">Si tienes dudas o necesitas asistencia, puedes contactarnos directamente.</p>
        </div>

        <div class="ayuda-contacto">
          <p class="texto-ayuda">Medios de contacto directos:</p>
          <ul class="lista-contacto">
            <li>
              <div class="icon-circle"><i class="fa-solid fa-phone"></i></div>
              <div class="contact-text">
                <strong>Teléfono:</strong>
                <a href="tel:+526676015">667 247 6316</a>
              </div>
            </li>
            <li>
              <div class="icon-circle"><i class="fa-solid fa-envelope"></i></div>
              <div class="contact-text">
                <strong>Correo:</strong>
                <a href="mailto:energyaniasolar@gmail.com">energyaniasolar@gmail.com</a>
              </div>
            </li>
          </ul>
        </div>
      </section>

    </div>

    <ModalExito 
      :mostrarExito="mostrarExito" 
      mensajeExito="¡Contraseña actualizada con éxito!" 
    />

  </div>
</template>

<script>
import Button from '@/components/Forms/Button.vue';
import userService from '@/services/userService.js';
import ModalExito from "../Modales/ModalExito.vue";

export default {
  components: { 
    Button,
    ModalExito 
  },
  data() {
    return {
      twoFactorEnabled: false,
      mostrarExito: false,
      mostrarLoader: false,
      showPass: {
        old: false,
        new: false,
        confirm: false
      },
      passwords: {
        current_password: '',
        new_password: '',
        confirm_password: '',
      },
    };
  },
  methods: {
    async changePassword() {
      const userData = JSON.parse(localStorage.getItem('userData'));

      if (!this.passwords.current_password || !this.passwords.new_password || !this.passwords.confirm_password) {
        alert('Todos los campos de contraseña son obligatorios.');
        return;
      }
      if (this.passwords.new_password !== this.passwords.confirm_password) {
        alert('La nueva contraseña y la confirmación no coinciden.');
        return;
      }
      if (!userData || !userData.id_usuario) {
        alert('Error: No se pudo identificar al usuario.');
        return;
      }

      const dataToSend = {
        current_password: this.passwords.current_password,
        new_password: this.passwords.new_password,
      };

      try {
        this.mostrarLoader = true;
        await userService.changePassword(userData.id_usuario, dataToSend);

        this.mostrarLoader = false;
        this.mostrarExito = true;

        this.passwords.current_password = '';
        this.passwords.new_password = '';
        this.passwords.confirm_password = '';

        setTimeout(() => {
          this.mostrarExito = false;
        }, 2000);

      } catch (error) {
        this.mostrarLoader = false;
        console.error("Error al cambiar contraseña:", error.response || error);
        let errorMessage = 'Ocurrió un error al intentar cambiar la contraseña.';
        if (error.response && error.response.data && error.response.data.error) {
          errorMessage = error.response.data.error;
        }
        alert(`Error: ${errorMessage}`);
      }
    }
  }
};
</script>

<style scoped>
.seguridad-container {
  --color-primario: #4652e8;
  --color-borde: #e2e8f0;
  --color-texto: #1e293b;
  --color-texto-secundario: #64748b;
  --bg-input: #ffffff;
  width: 100%;
  box-sizing: border-box;
}

.seguridad-container * {
  box-sizing: border-box;
}
.section-header-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.section-subtitle {
  font-size: 18px;
  font-weight: 600;
  color: #333;
  margin: 0;
}

.status-badge.protected {
  background: #ecfdf5;
  color: #10b981;
  padding: 4px 12px;
  border-radius: 20px;
  font-size: 0.8rem;
  font-weight: 600;
  border: 1px solid #a7f3d0;
}

.view-card {
  background: #ffffff;
  border: 1px solid var(--color-borde);
  border-radius: 12px;
  padding: 30px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}

.informacionSeguridad {
  border-bottom: 1px solid var(--color-borde);
  padding-bottom: 30px;
  margin-bottom: 30px;
}

.header-interno {
  margin-bottom: 20px;
}

.security-title {
  font-size: 16px;
  font-weight: 700;
  color: #29b9f6;
  margin: 0 0 5px 0;
}

.security-description {
  font-size: 14px;
  color: var(--color-texto-secundario);
  margin: 0;
}

.inputs-grid-security {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
  margin-bottom: 25px;
  width: 100%;
}

.form-group {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.form-group label {
  font-size: 14px;
  font-weight: 600;
  color: var(--color-texto);
  margin-bottom: 8px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.password-wrapper {
  position: relative;
  width: 100%;
  display: flex;
  align-items: center;
}

.form-group input {
  height: 42px;
  width: 100%;
  padding: 0 40px 0 12px;
  border: 1px solid var(--color-borde);
  border-radius: 8px;
  font-size: 14px;
  background: var(--bg-input);
  outline: none;
  transition: border-color 0.2s;
}

.form-group input:focus {
  border-color: #29b9f6;
}

.toggle-icon {
  position: absolute;
  right: 12px;
  color: #94a3b8;
  cursor: pointer;
  font-size: 0.9rem;
  transition: color 0.2s;
  z-index: 2;
}

.toggle-icon:hover {
  color: #29b9f6;
}

.actions-row {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  gap: 15px;
}

.btn-change-password {
  background-color: #2a428c;
  color: white;
  padding: 12px 25px;
  border-radius: 6px;
  font-weight: bold;
  cursor: pointer;
  border: none;
  user-select: none;
}

.btn-change-password:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.ayuda-contacto {
  background: #fcfcfc;
  padding: 20px;
  border-radius: 8px;
  border: 1px solid var(--color-borde);
}

.texto-ayuda {
  font-weight: 600;
  font-size: 14px;
  margin-top: 0;
  margin-bottom: 15px;
}

.lista-contacto {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.lista-contacto li {
  display: flex;
  align-items: center;
  gap: 12px;
}

.icon-circle {
  width: 32px;
  height: 32px;
  background: #29b9f61a;
  color: #2a428c;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
}

.contact-text {
  font-size: 14px;
  color: var(--color-texto);
}

.contact-text a {
  color: #29b9f6;
  text-decoration: none;
  font-weight: 500;
  margin-left: 5px;
}

@media (max-width: 768px) {
  .inputs-grid-security {
    grid-template-columns: 1fr;
    gap: 15px;
  }
  .actions-row {
    flex-direction: column;
    align-items: flex-start;
  }
  .btn-change-password {
    width: 100%;
  }
}
</style>